<template>
    <div class="MarketingPlanObjects">
		<tabs type="primary" 
			:activeTab="strCurrentTab"
			@change="OnTabChange"
            tabContentClasses="tab-opt"
            centered
            inline
            round	
			v-loading.fullscreen.lock="$GVO.fullscreenLoading"
			element-loading-text="Загрузка данных..."
			element-loading-spinner="el-icon-loading"
			element-loading-background="rgba(0, 0, 0, 0.8)"	
            class="card card-plain">
            <tab-pane :id="'base_conf'" v-if="this.$GVO.my_profile.adm == 1">
                <template v-slot:label>
					<span class="tab-label">
						<span>Общие настройки</span>
					</span>
                </template>
				
				<card>
					<h4>Задайте общие настройки</h4>
					<ReFormPrinter :masFormConfig="masAllFormParams" :objSaveApiMethod="currentApiFormMethod" :SuccessGo="SuccessGo" SuccessBtnText="Сохранить" />
				</card>
            </tab-pane>

            <tab-pane :id="'packages'" v-if="false">
                <template v-slot:label>
                <span class="tab-label">
                    <span>Рекламные пакеты</span>
                </span>
                </template>

				<div>
					<div class="d-flex justify-content-between">
						<div class="filter-tag-row">
							<ReFilterBtn v-model="bShowFilter" :bShowOptsCount="false"/>
							<span class="ml-3 el-tag el-tag--small el-tag el-tag--plain el-tag--primary" v-if="this.strCurrentTab == 'packages'">Пакетов: {{this.masObjects_total}}</span>
							<span class="ml-3 el-tag el-tag--small el-tag el-tag--plain el-tag--primary" v-if="this.strCurrentTab == 'plans'">Пакетов: {{this.masObjectsNew_total}}</span>
						</div>	
						
						<div class="mb-1 text-right" v-if="this.$GVO.my_profile.adm == 1 || this.$GVO.my_profile.AdsMaster == 1">
							<base-button @click="AddPackage()" type="primary" simple>Добавить пакет</base-button>
						</div>
					</div>
					<div class="col-lg-8" v-show="bShowFilter">
						<ReFilter :masAllFilterParams="masAllFilterParams" 
						v-model="objGetParams" 
						v-on:filterapply="OnFilterApply"
						name="MarketingPlanObjects"/>
					</div>
					<div>
						<card>
							<el-table :data="ApiDataTable" style="width: 100%;">
								<el-table-column
									label="ID"
									property="id"
									width="80"
								>
								</el-table-column>
								<!-- <el-table-column
									label="default"
									property="default"
									width="80"
								>
								</el-table-column> -->
								<el-table-column 
									min-width="180"
									label="Название пакета"
									property="name"
								>
								</el-table-column>
								<el-table-column 
									min-width="90"
									label="Регион"
									property="regionId"
								>
								</el-table-column>
								<el-table-column 
									min-width="180"
									label="Тип сделки"
									property="deal_type"
								>
									<template v-slot="scope">	
										<span v-if="scope.row.deal_type == 'RENT'"> Аренда</span>
										<span v-if="scope.row.deal_type == 'SELL'"> Продажа</span>
									</template>
								</el-table-column>
								<!-- <el-table-column 
									min-width="180"
									label="Тип объекта"
									property="object_type"
								>
								</el-table-column> -->
								<el-table-column 
									min-width="160"
									label="Объект"
									property="title"
								>
								</el-table-column>
								<el-table-column 
									min-width="160"
									label="Срок размещения"
									property="days"
								>
								</el-table-column>
								<el-table-column 
									min-width="260"
									label="Кол-во площадок"
									property="sites_count"
								>
									<template v-slot="scope">	
										Площадки: {{scope.row.sites_count}} - Стоимость: {{scope.row.price}} ₽
									</template>
									<!-- <template slot-scope="scope">	
										Площадки: {{scope.row.sites_count}} - Стоимость: {{scope.row.sites_price}}
									</template> -->
								</el-table-column>
								<el-table-column
										width="280"
										label="Действие"
										align="right"                    	
								>
									<template v-slot="scope">	
										<el-tooltip content="Управление доступами к пакетам" placement="top">
											<el-button class="no-border my-0">
												<button class="btn btn-icon btn-simple btn-info" @click="GoAccessEdit(scope.row)">
													<i class="tim-icons icon-settings-gear-63"></i>
												</button>											
											</el-button>
										</el-tooltip>

										<template v-if="canEdit">

											<el-tooltip content="Добавить рекламные площадки" placement="top" >
												<el-button class="no-border my-0">
													<button class="ml-1 btn btn-icon btn-simple btn-success" @click="GoAddSites(scope.row)">
														<i class="tim-icons icon-simple-add"></i>
													</button>											
												</el-button>
											</el-tooltip>	
										

											<el-tooltip content="Редактировать пакет" placement="top">
												<el-button class="no-border my-0 mr-3">
													<button class="ml-1 btn btn-icon btn-simple btn-primary" @click="GoEdit(scope.row)">
														<i class="tim-icons icon-pencil"></i>
													</button>											
												</el-button>
											</el-tooltip>		

											<!-- <el-tooltip content="Удалить пакет" placement="top">
												<el-button class="no-border my-0">
													<button class="ml-1 btn btn-icon btn-simple btn-danger" @click="DeleteRow(scope.row)">
														<i class="tim-icons icon-trash-simple"></i>
													</button>											
												</el-button>
											</el-tooltip>		 -->
											
											<base-switch :key="scope.row.id"
												v-model="scope.row.act"
												type="primary"
												on-text="Вкл"
												off-text="Выкл"
												@change="ChangeAct(scope.row)"
											></base-switch>
										</template>	
												
									</template>
								</el-table-column>
							
							</el-table>

							<Pagination class="mt-3" :class="[{'': parseInt(masObjects_total) > 0}, {'d-none': parseInt(masObjects_total) < 1}]"
								:type="'info'" 
								:total="parseInt(masObjects_total)" 
								:perPage="parseInt(10)"
								:value="parseInt(typeof objGetParams.p == 'undefined' ? 1:objGetParams.p)"
								:pClick="pClick">
							</Pagination>
						</card>
					</div>
				</div>
            </tab-pane>
			<tab-pane :id="'plans'">
			    <template v-slot:label>
			        <span class="tab-label">
			            <span>Новые Рекламные пакеты</span>
			        </span>
			    </template>
				<div>
					<div class="d-flex justify-content-between">
						<div class="filter-tag-row">
							<ReFilterBtn v-model="bShowFilter" :bShowOptsCount="false"/>
							<span class="ml-3 el-tag el-tag--small el-tag el-tag--plain el-tag--primary">Групп: {{this.masObjectsNew_total}}</span>
						</div>	
						
						<div class="mb-1 text-right" v-if="this.$GVO.my_profile.adm == 1 || this.$GVO.my_profile.AdsMaster == 1">
							<base-button @click="AddNewPackage()" type="primary" simple>Добавить группу</base-button>
						</div>
					</div>
					<div class="col-lg-8" v-show="bShowFilter">
						<ReFilter :masAllFilterParams="masAllFilterParams" 
						v-model="objGetParams" 
						v-on:filterapply="OnFilterApply"
						name="MarketingPlanObjects"/>
					</div>
					<div>
						<card>
							<el-table :data="ApiNewDataTable" style="width: 100%;">
								<el-table-column
									label="ID"
									property="id"
									width="80"
								>
								</el-table-column>
								<!-- <el-table-column
									label="default"
									property="default"
									width="80"
								>
								</el-table-column> -->
								<el-table-column 
									min-width="180"
									label="Название группы"
									property="name"
								>
								</el-table-column>
								<el-table-column 
									min-width="160"
									label="Срок размещения"
									property="days"
								>
								</el-table-column>
								<el-table-column 
									min-width="160"
									label="Ограничения"
									property="use_limit"
								>
									<template v-slot="scope">	
										{{  scope.row.use_limit>0? scope.row.use_limit : 'Без ограничений' }}
									</template>
								</el-table-column>								
								<!--
								<el-table-column 
									min-width="260"
									label="Кол-во площадок"
									property="sites_count"
								>
									<template slot-scope="scope">	
										Площадки: {{scope.row.sites_count}} - Стоимость: {{scope.row.price}} ₽
									</template>
								</el-table-column>
								-->
								<el-table-column
										width="280"
										label="Действие"
										align="right"                    	
								>
									<template v-slot="scope">
										<!-- 
										<el-tooltip content="Управление доступами к пакетам" placement="top">
											<el-button class="no-border my-0">
												<button class="btn btn-icon btn-simple btn-info" @click="GoAccessEdit(scope.row)">
													<i class="tim-icons icon-settings-gear-63"></i>
												</button>											
											</el-button>
										</el-tooltip>
										-->
										<template v-if="canEdit">
											<!--
											<el-tooltip content="Добавить рекламные площадки" placement="top" >
												<el-button class="no-border my-0">
													<button class="ml-1 btn btn-icon btn-simple btn-success" @click="GoAddSites(scope.row)">
														<i class="tim-icons icon-simple-add"></i>
													</button>											
												</el-button>
											</el-tooltip>	
											-->
											
											<el-tooltip content="Редактировать пакет" placement="top">
												<el-button class="no-border my-0 mr-3">
													<button class="ml-1 btn btn-icon btn-simple btn-primary" @click="GoNewEdit(scope.row)">
														<i class="tim-icons icon-pencil"></i>
													</button>											
												</el-button>
											</el-tooltip>		

											<!-- <el-tooltip content="Удалить пакет" placement="top">
												<el-button class="no-border my-0">
													<button class="ml-1 btn btn-icon btn-simple btn-danger" @click="DeleteRow(scope.row)">
														<i class="tim-icons icon-trash-simple"></i>
													</button>											
												</el-button>
											</el-tooltip>		 -->
											
											<base-switch :key="scope.row.id"
												v-model="scope.row.act"
												type="primary"
												on-text="Вкл"
												off-text="Выкл"
												@change="ChangeActNew(scope.row)"
											></base-switch>
											<!-- <div class="d-flex justify-content-end"></div> -->
										</template>	
												
									</template>
								</el-table-column>
							
							</el-table>

							<Pagination class="mt-3" :class="[{'': parseInt(masObjectsNew_total) > 0}, {'d-none': parseInt(masObjectsNew_total) < 1}]"
								:type="'info'" 
								:total="parseInt(masObjectsNew_total)" 
								:perPage="parseInt(50)"
								:value="parseInt(typeof objGetParams.p == 'undefined' ? 1:objGetParams.p)"
								:pClick="pClickNew">
							</Pagination>
						</card>
					</div>					
				</div>
			</tab-pane>			
			<tab-pane :id="'sites'">
			    <template v-slot:label>
			        <span class="tab-label">
			            <span>Площадки</span>
			        </span>
			    </template>
				<MarketingSitesEditor
					:canEdit="canEdit"
				/>
			</tab-pane>			
        </tabs>
    </div>
</template>

<script>

import {eventEmitter} from "src/plugins/globalComponents.js";
import { Table, TableColumn, Select, Option, Tooltip, Button } from 'element-ui';
import { TabPane, Tabs, BaseSwitch } from 'src/components';
import ReFormPrinter from "src/our_components/FormPrinter/ReFormPrinter.vue";
// import DashboardLayout from "../../our_pages/Layout/DashboardLayout.vue";
import Pagination from 'src/our_components/RePagination';
import ReFilterBtn from 'src/our_components/FilterPrinter/ReFilterBtn.vue';
import ReFilter from 'src/our_components/FilterPrinter/ReFilter.vue';
// import ReObjFilter from '../../our_components/ReObjFilter.vue';
import tabsMixin from '../../mixins/tabs.js'
import MarketingSitesEditor from './MarketingSitesEditor.vue';

export default {
	name: 'MarketingPlanObjects-page',
	mixins: [tabsMixin],
	components: {
	    [Table.name]: Table,
    	[TableColumn.name]: TableColumn,
        [Option.name]: Option,
        [Select.name]: Select,
        [Tooltip.name]: Tooltip,
        [Button.name]: Button,
		TabPane, 
		Tabs,
		ReFormPrinter,
		BaseSwitch,
		Pagination,
		ReFilterBtn,
		ReFilter,
		// ReObjFilter,
		MarketingSitesEditor,
	},
	props: {

	},
	data() {
		return {
			strCurrentTab: 'plans', // base_conf||packages
			ApiData: [],
			masAllFormParams: this.currentFormConfig(),
			currentApiFormMethod: this.currentApiFormMethodComp(),
			bShowFilter: false,
			masAllFilterParams: this.currentFilterConfig(),
			objGetParams:{},
			ApiDataTable: [],
			ApiNewDataTable: [],
			ApiSitesTable: [],
			masObjects_total: 0,
			masObjectsNew_total: 0,
			test_filter:'{}',
		};
	},
	computed: {
		canEdit(){
			if(this.$GVO.my_profile.adm == 1 || this.$GVO.my_profile.AdsMaster == 1) {
				return true;
			} return false;
		}
	},
	methods: {
		getApiData(){
			return;
			this.objGetParams = this.$GVO.GetAllGet();
			let filter = {};
			if (!this.$GVO.isEmpty(this.objGetParams)) {
				//console.log('getApi',this.objGetParams);
				// filter = this.objGetParams;
				filter = this.$GVO.SafeParseJson(JSON.stringify(this.objGetParams));
			}

			this.$GVO.ApiCall('marketing_plan.GET',{flt:{/*'act':1,*/ ...filter, c2p:10}})
			.then((objApi) => {
				this.ApiData = [];
				this.masObjects_total=0;
				if(objApi.success === true){
					if(objApi.data.length > 0){
						this.ApiDataTable = objApi.data;
						if(objApi.total!=undefined) { this.masObjects_total=objApi.total; }
					}else{
						this.ApiDataTable=[];
					}
				}
			}).catch(errorObjApi => {console.error(errorObjApi); this.masApi_total=0; this.ApiData = [];});
		},
			
		getApiNewData(){
			this.objGetParams = this.$GVO.GetAllGet();
			let filter = {};
			if (!this.$GVO.isEmpty(this.objGetParams)) {
				//console.log('getApi',this.objGetParams);
				// filter = this.objGetParams;
				filter = this.$GVO.SafeParseJson(JSON.stringify(this.objGetParams));
			}

			this.$GVO.ApiCall('marketing_plan.GET_NEW',{flt:{/*'act':1,*/ ...filter, c2p:50}})
			.then((objApi) => {
				this.ApiNewDataTable = [];
				this.masObjectsNew_total=0;
				if(objApi.success === true){
					if(objApi.data.length > 0){
						this.ApiNewDataTable = objApi.data;
						if(objApi.total!=undefined) { this.masObjectsNew_total=objApi.total; }
					}else{
						this.ApiNewDataTable=[];
					}
				}
			}).catch(errorObjApi => {console.error(errorObjApi); this.masObjectsNew_total=0; this.ApiNewDataTable = [];});
		},		
		currentFormConfig() {
			this.$GVO.ApiCall('marketing_settings.GET_FORM_MODEL',{flt:{'result_id':1}})
				.then((objApi) => {
					if(objApi.success){
						this.masAllFormParams = objApi.config;
					}
				})
				.catch(errorObjApi => console.error(errorObjApi));
			return [];
		},
		currentApiFormMethodComp(){
            return {apiMethod:'marketing_settings.INSUPD',apiParam:{iData:[],flt:{'id':1}}};
        },
		SuccessGo(evt,dopParam){
	        
		},
		DeleteRow(row){
			return;
			// console.log(row);
			if(row.id != null){
				this.$GVO.ApiCall('marketing_plan.DEL',{ flt:{id: row.id}}) 
					.then((objApi) => {
						if(objApi.success === true){
							this.getApiData();
						}else{
							alert('Не удалилось');
						}
					}).catch(errorObjApi => {console.error(errorObjApi);});
			}
			this.getApiData();
		},
		ChangeAct(row){
			this.$GVO.ApiCall('marketing_plan.CHANGE_ACT',{flt:{id:row.id,},iData:{act:row.act}})
			.then(objApi=>{
				if(objApi.success === true && objApi.data){
					// console.log(row.act);
					row.act=='1'?true:false;	
				}					
			})
		},
		ChangeActNew(row){
			this.$GVO.ApiCall('marketing_plan.CHANGE_GROUP_ACT',{flt:{id:row.id,},iData:{act:row.act}})
			.then(objApi=>{
				if(objApi.success === true && objApi.data){
					// console.log(row.act);
					row.act=='1'?true:false;	
				}					
			})
		},
		GoEdit(row){
			//console.log('GoEdit',row);
			if(row.id != null){
				this.$router.push({path: `/data/module/mo/marketing_plan/edit/${row.id}`});
			}
		},
		GoNewEdit(row){
			//console.log('GoEdit',row);
			if(row.id != null){
				this.$router.push({path: `/data/module/mo/marketing_plan/id/${row.id}`});
			}
		},
		// OnTabChange(strTabId){
			// this.$emit('input', strTabId);
			// this.$emit('change', strTabId);
		// },
		SaveForm(){

		},
		AddNewPackage(){
			this.$router.push({path: '/data/module/mo/marketing_plan/id/0'});
		},
		AddPackage(){
			this.$router.push({path: '/data/module/mo/marketing_plan/add'});
		},
		GoAccessEdit(row){
			if(row.id != null){
				this.$router.push({path: `/data/module/mo/marketing_plan/access_edit/${row.id}`});
			}
		},
		GoAddSites(row){
			if(row.id != null){
				this.$router.push({path: `/data/module/mo/marketing_sites/${row.id}`});
			}
		},
		pClick(e){
			let strItogGetParams = '';
			let objItogGetParams = this.$GVO.GetAllGet();
			// this.objGetParams['p'] = parseInt(e);
			objItogGetParams.p=parseInt(e);
			strItogGetParams = this.$GVO.ObjToQueryString(objItogGetParams).substr(1);
			this.$router.push({path: location.pathname+'?'+strItogGetParams});
			// this.OnFilterApply(strItogGetParams);
			// this.getApiData();
			this.getApiNewData();
			// this.objGetParams['p'] = parseInt(e);
			// this.OnFilterApply();
		},
		pClickNew(e){
			let strItogGetParams = '';
			let objItogGetParams = this.$GVO.GetAllGet();
			objItogGetParams.p=parseInt(e);
			strItogGetParams = this.$GVO.ObjToQueryString(objItogGetParams).substr(1);
			this.$router.push({path: location.pathname+'?'+strItogGetParams});
			this.getApiNewData();
		},		
		currentFilterConfig(){
			this.$GVO.ApiCall('marketing_plan.GET_FILTER',{})
			.then((objApi) => {
				// console.log(objApi);
				if(objApi.success){
					// this.masAllFilterParams = objApi.config;
					// this.masAllFilterParams = this.$GVO.unlinkObject(objApi.config);
					// eventEmitter.$emit('OnFilterConfigLoad', this.masAllFilterParams);

					this.masAllFilterParams = objApi.config;
					eventEmitter.$emit('OnFilterConfigLoad',  this.masAllFilterParams);
					// console.log('currentFilterConfig',objApi.config);
				}
			})
			.catch(errorObjApi => console.error(errorObjApi));
			return [];
		},
		OnFilterApply(data){
			if(typeof data != 'undefined' && typeof this.objGetParams['p'] != 'undefined'){
				delete this.objGetParams['p'];
			}

			for (const key in this.objGetParams) {
				if (Object.hasOwnProperty.call(this.objGetParams, key)) {
					if(this.objGetParams[key] == '') delete this.objGetParams[key];
				}
			}
			let strItogGetParams = this.$GVO.ObjToQueryString(this.objGetParams).substr(1);
			//console.log('OnFilterApply',strItogGetParams,this.objGetParams);
			this.$router.push({path: location.pathname+'?'+strItogGetParams});
			eventEmitter.$emit('OnFilterApply', this.objGetParams);
			// this.getApiData();
			this.getApiNewData();
		},	

	},		
	mounted() {
		// var queryParams = new URLSearchParams(window.location.search);
		// // queryParams.set("dSearchType", "mobj");
		// history.replaceState(null, null, "?"+queryParams.toString());
		// this.objGetParams = this.$GVO.GetAllGet();
		// this.getApiData();
		this.getApiNewData();
	}
};
</script>
<style scoped>
	.MarketingPlanObjects >>> .bntGroup{
		display: flex;
		justify-content: space-around;
	}
	.MarketingPlanObjects >>> .bntGroup > *{width: 125px;}

	.MarketingPlanObjects >>> .nav-pills .nav-item .nav-link {
		padding: 0px 20px;
	}

	#alt_agent_name {margin-bottom: 10px;}

	.MarketingPlanObjects >>> .bootstrap-switch {
    width: 70px !important;
    margin: 0;
	}
	.MarketingPlanObjects >>> .bootstrap-switch-container {
		width: 106px !important;
	}

	
</style>
